enum Action {
  SHOW = 'show',
  HIDE = 'hide',
}

export default Action;
